import moment from "moment";
import { BASE_URL } from "./BaseUrl";
import {
  convertTimeHHMMSS,
  convertTo12HourFormat,
  // convertTimeRange,
} from "../components/common-data/Converts";

export const fetchUsers = async (TOKEN, qps, pageNo, limit) => {
  let url = `user?page=${pageNo}&limit=${limit ? limit : 10}&${qps ? qps : ""}`;

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allUsers = responseJson?.data?.map((item) => ({
      value: item.uid,
      label: `${item.name}/${item.mobile}`,
    }));

    return allUsers;
  } catch (error) {
    console.error("fetchUsers=> ", error);
    throw error;
  }
};

export const fetchInHouseUsers = async (TOKEN, qps, pageNo, limit) => {
  let url = `user/otherusers?page=${pageNo}&limit=${
    limit ? limit : 10
  }&status=active&${qps ? qps : ""}`;

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allUsers = responseJson?.data?.map((item) => {
      const shiftTimings = item?.shift_details?.map((shift) => {
        const startTime = shift?.start_time
          ? moment(shift.start_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
          : "";
        const endTime = shift?.end_time
          ? moment(shift.end_time, "HH:mm").tz("Asia/Kolkata").format("h:mmA")
          : "";
        return `${startTime}-${endTime}`;
      });

      const shiftTiming = shiftTimings
        ? shiftTimings?.join(", ")
        : "No Shift Found";

      return {
        value: item?.user_id,
        label: `${item.name} ${shiftTiming ? `(${shiftTiming})` : ""} / ${
          item.account_type === "receptionist"
            ? "Sales Executive"
            : item.account_type?.replace(/_/g, " ")
        } (${item.mobile})`,
        info: item,
        pagination: responseJson?.pagination || 0,
      };
    });

    // const allUsers = responseJson?.data?.map((item) => ({
    //   value: item.user_id,
    //   label: `${item.name} (${
    //     item.account_type === "receptionist"
    //       ? "Sales Executive"
    //       : item.account_type?.replace(/_/g, " ")
    //   }) / ${item.mobile}`,
    // }));

    return allUsers;
  } catch (error) {
    console.error("fetchInHouseUsers=> ", error);
    throw error;
  }
};

export const fetchMealTimes = async (TOKEN, qps, pageNo, limit) => {
  let url = `dietTiming/get?page=${pageNo}&limit=${
    limit ? limit : 10
  }&status=active&${qps ? qps : ""}`;

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allUsers = responseJson?.data?.map((item) => ({
      value: item?.uid,
      label:
        item?.name?.replace(/_/g, " ").charAt(0).toUpperCase() +
        item?.name?.replace(/_/g, " ").slice(1),
      info: item,
    }));

    return allUsers;
  } catch (error) {
    console.error("fetchMealTimes=> ", error);
    throw error;
  }
};

export const fetchDietPakagesDropdwon = async (
  TOKEN,
  queryParameters,
  pageNo,
  limit
) => {
  let url = `dietcat/new?page=${pageNo ? pageNo : 1}&limit=${
    limit ? limit : 10
  }`;

  if (queryParameters) {
    url += `&${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    const allPackages = responseJson?.data?.map((item) => ({
      value: item.uid,
      label: `${item.name} (${item.type2_name || "NA"}/${
        item.type1_name || "NA"
      })`,
      info: item,
    }));

    return allPackages;
  } catch (error) {
    console.error("fetchDietPakagesDropdwon=> ", error);
    throw error;
  }
};

export const fetchRegularPlans = async (
  TOKEN,
  queryParameters,
  pageNo,
  limit
) => {
  let url = `plan?page=${pageNo ? pageNo : 1}&limit=${
    limit ? limit : 10
  }&status=active`;

  if (queryParameters) {
    url += `&${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    const allPackages = responseJson?.data?.map((item) => ({
      value: item.uid,
      label: `${item.plan_name} (${item.duration}Days)`,
      info: item,
    }));

    return allPackages;
  } catch (error) {
    console.error("fetchRegularPlans=> ", error);
    throw error;
  }
};

export const fetchAddons = async (TOKEN, queryParameters, pageNo, limit) => {
  let url = `addoncat?page=${pageNo ? pageNo : 1}&limit=${
    limit ? limit : 10
  }&status=active`;

  if (queryParameters) {
    url += `&${queryParameters}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    const allPackages = responseJson?.data?.map((item) => ({
      value: item.uid,
      label: `${item.name} (${item.is_pt ? "PT" : "Not PT"})`,
      info: item,
    }));

    return allPackages;
  } catch (error) {
    console.error("fetchAddons=> ", error);
    throw error;
  }
};

export const fetchAllCampaigns = async (filters, TOKEN) => {
  let url = `campaign`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();
    const allCampaigns = responseJson?.data?.map((item) => ({
      value: item?.campaign_id,
      label: `${item.campaign_name} (${
        item.campaign_type === "1"
          ? "P2P"
          : item.campaign_type === "2"
          ? "IVR"
          : ""
      })`,
      isIVR: item.campaign_type === "2" ? true : false,
      info: item,
    }));
    return allCampaigns;
  } catch (error) {
    console.error("fetchAllCampaigns=> ", error);
    throw error;
  }
};

export const fetchtrainerShifts = async (filters, TOKEN) => {
  let url = `trainerShift/getShiftSlots`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allShifts = responseJson?.data?.slot_details?.map((item) => ({
      value: item?.slot_id,
      label: `${
        item.start_time ? convertTimeHHMMSS(item.start_time) : "NA"
      } TO ${item.end_time ? convertTimeHHMMSS(item.end_time) : "NA"}`,
      info: item,
    }));
    return allShifts;
  } catch (error) {
    console.error("fetchtrainerShifts=> ", error);
    throw error;
  }
};

export const fetchTrainersBySlot = async (filters, TOKEN) => {
  let url = `ptTrial/pt_trial_trainer_availability`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allShifts = responseJson?.data?.map((item) => ({
      value: item?.trainer_id,
      label:
        item?.shift_timing
          ?.map(
            (shift) =>
              `${
                shift?.start_time ? convertTimeHHMMSS(shift.start_time) : ""
              } - ${shift.end_time ? convertTimeHHMMSS(shift.end_time) : ""}`
          )
          .join(",") || "No Shift Found",
      info: item,
    }));

    return allShifts;
  } catch (error) {
    console.error("fetchTrainersBySlot=> ", error);
    throw error;
  }
};

export const fetchReceptionistBySlot = async (filters, TOKEN) => {
  let url = `staff/report?page=1&limit=100&account_type=receptionist`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allShifts = responseJson?.data?.map((item) => ({
      value: item?.user_id,
      label: `${item?.name} /
        (${
          item?.shift_details
            ?.map(
              (shift) =>
                `${
                  shift?.start_time ? convertTimeHHMMSS(shift.start_time) : ""
                } - ${shift.end_time ? convertTimeHHMMSS(shift.end_time) : ""}`
            )
            .join(",") || "No Shift Found"
        })`,
      info: item,
    }));

    return allShifts;
  } catch (error) {
    console.error("fetchReceptionistBySlot=> ", error);
    throw error;
  }
};

export const fetchTrainerNameBySlot = async (filters, TOKEN) => {
  let url = `ptTrial/pt_trial_trainer_availability`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allShifts = responseJson?.data?.map((item) => ({
      value: item?.trainer_id || "",
      label: item?.trainer_name || "NA",
      info: item || {},
    }));

    return allShifts;
  } catch (error) {
    console.error("fetchTrainerNameBySlot=> ", error);
    throw error;
  }
};

export const fetchSessions = async (filters, TOKEN) => {
  let url = `session/get_pt_session`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allSessions = responseJson?.data?.map((item) => ({
      value: item?.uid || "",
      label: `${item?.n_session || 0} Sessions For ${item?.duration || 0} Days`,
      info: item || {},
    }));

    return allSessions;
  } catch (error) {
    console.error("fetchSessions=> ", error);
    throw error;
  }
};

export const fetchAgents = async (filters, TOKEN) => {
  let url = `campaign/agents`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    let allSessions;

    if (filters.is_mapped === 1) {
      allSessions = responseJson?.data?.map((item) => ({
        value: item?.mopr_agent_id || "",
        label: `${item?.name || "NA"} / ${item?.mobile || ""}`,
        info: item || {},
      }));
    } else {
      allSessions = responseJson?.data?.map((item) => ({
        value: item?.uuid || "",
        label: `${item?.name || "NA"} / ${item?.contact_number || ""}`,
        info: item || {},
      }));
    }

    return allSessions;
  } catch (error) {
    console.error("fetchAgents=> ", error);
    throw error;
  }
};

export const fetchAllMembers = async (filters, TOKEN) => {
  let url = `member`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allSessions = responseJson?.data?.map((item) => ({
      value: item?.user_id || "",
      label: `${item?.name || ""}/${item?.mobile || ""}`,
      pagination: responseJson?.pagination,
      info: item || {},
    }));

    return allSessions;
  } catch (error) {
    console.error("fetchAllMembers=> ", error);
    throw error;
  }
};

export const fetchSourceName = async (filters, TOKEN) => {
  let url = `leads/lead-source`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allSources = responseJson?.data?.length > 0 ? responseJson.data : [];

    return allSources;
  } catch (error) {
    console.error("fetchSourceName=> ", error);
    throw error;
  }
};

export const fetchLeadCaptureKeyword = async (filters, TOKEN) => {
  let url = `wati/predefined_msg?lead_capture=true`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allKeyword = {
      data: responseJson?.data || [],
      pagination: responseJson?.pagination || [],
      dropdown: responseJson?.data?.map((item) => ({
        value: item?.uid || "",
        label: item?.predefined_msg || "",
        // label: `${item?.tab_name || ""}/${item?.sheet_name || ""}`,
        pagination: responseJson?.pagination,
        info: item || {},
      })),
    };

    return allKeyword;
  } catch (error) {
    console.error("fetchLeadCaptureKeyword=> ", error);
    throw error;
  }
};

export const fetchCentralisedPlans = async (filters, TOKEN) => {
  let url = `plan`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allKeyword = {
      data: responseJson?.data || [],
      pagination: responseJson?.pagination || [],
      dropdown: responseJson?.data?.map((item) => ({
        value: item?.uid || "",
        label: item?.plan_name || "",
        pagination: responseJson?.pagination,
        info: item || {},
      })),
    };

    return allKeyword;
  } catch (error) {
    console.error("fetchCentralisedPlans=> ", error);
    throw error;
  }
};

export const fetchLeadSource = async (filters, TOKEN) => {
  let url = `leads/source/get`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allKeyword = {
      data: responseJson?.data || [],
      pagination: responseJson?.pagination || [],
    };

    return allKeyword;
  } catch (error) {
    console.error("fetchLeadSource=> ", error);
    throw error;
  }
};

export const fetchGymCities = async (filters, TOKEN) => {
  let url = `gym/cities/v2`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allCities = responseJson?.data?.map((item) => ({
      value: item?.city_id || "",
      label: item?.city,
      info: item || {},
    }));

    return allCities;
  } catch (error) {
    console.error("fetchGymCities=> ", error);
    throw error;
  }
};

export const fetchLeadFromSource = async (filters, TOKEN) => {
  let url = `leads/lead-from`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allKeyword = responseJson?.data?.map((item) => ({
      value: item?.lead_from || "",
      label:
        // item?.lead_from === "lms"
        // ? "LMS"
        // : item?.lead_from === "direct"
        // ? "LMS (Directly Added From LMS)"
        item?.lead_from === "lms" || item?.lead_from === "direct"
          ? "LMS (Directly Added From LMS)"
          : item?.lead_from === "expiring"
          ? "Renewal (Renewal and Expiring Members)"
          : item?.lead_from === "recurring"
          ? "Recurring (Recurring Members)"
          : item?.lead_from === "one_time_link"
          ? "One Time Payment Link"
          : item?.lead_from === "raw_lead"
          ? "RLMS (Raw Leads)"
          : item?.lead_from === "unpaid"
          ? "Unpaid (Unpaid Members)"
          : item?.lead_from?.replace(/_/g, " ") || "",
    }));

    return allKeyword;
  } catch (error) {
    console.error("fetchLeadFromSource=> ", error);
    throw error;
  }
};

export const fetchUTMParams = async (filters, TOKEN) => {
  let url = `leads/utm_kewords_filters`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const {
      utm_campaign,
      utm_content,
      utm_medium,
      utm_term,
      ga_campaignid,
      ga_medium,
      ga_adgroupid,
      ga_device,
      ga_keyword,
      ga_location,
      gclid,
    } = responseJson?.data || {};

    const utmCampaign =
      utm_campaign?.length > 0
        ? utm_campaign
        : ga_campaignid?.length > 0
        ? ga_campaignid
        : [];
    const utmMedium =
      utm_medium?.length > 0
        ? utm_medium
        : ga_medium?.length > 0
        ? ga_medium
        : [];

    const allUTMParams = {
      utm_campaign: utmCampaign?.map((item) => ({
        value: item || "",
        label: item || "",
      })),
      utm_content: utm_content?.map((item) => ({
        value: item || "",
        label: item || "",
      })),
      utm_medium: utmMedium?.map((item) => ({
        value: item || "",
        label: item || "",
      })),
      utm_term: utm_term?.map((item) => ({
        value: item || "",
        label: item || "",
      })),
      ad_group_id: ga_adgroupid?.map((item) => ({
        value: item || "",
        label: item || "",
      })),
      device: ga_device?.map((item) => ({
        value: item || "",
        label: item || "",
      })),
      keyword: ga_keyword?.map((item) => ({
        value: item || "",
        label: item || "",
      })),
      location: ga_location?.map((item) => ({
        value: item || "",
        label: item || "",
      })),
      g_clid: gclid?.map((item) => ({
        value: item || "",
        label: item || "",
      })),
    };

    return allUTMParams;
  } catch (error) {
    console.error("fetchUTMParams=> ", error);
    throw error;
  }
};

export const fetchOperatorValues = async (filters, TOKEN) => {
  let url = `leads/source/operator`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allCities = responseJson?.data?.map((item) => ({
      value: item?.operator_value || "",
      label: item?.operator_name,
      info: item || {},
    }));

    return allCities;
  } catch (error) {
    console.error("fetchOperatorValues=> ", error);
    throw error;
  }
};

export const fetchExpenseProcessManagers = async (filters, TOKEN) => {
  let url = `expense/process_manager`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allCats = responseJson?.data?.map((item) => ({
      value: item.user_id,
      label: item.user_name,
      info: item,
    }));

    return allCats;
  } catch (error) {
    console.error("fetchExpenseProcessManagers=> ", error);
    throw error;
  }
};

export const fetchExpenseAccountants = async (filters, TOKEN) => {
  let url = `expense/process_manager?role_type=accountant`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allCats = responseJson?.data?.map((item) => ({
      value: item.user_id,
      label: item.user_name,
      info: item,
    }));

    return allCats;
  } catch (error) {
    console.error("fetchExpenseAccountants=> ", error);
    throw error;
  }
};

export const fetchAllAceessCategories = async (filters, TOKEN) => {
  let url = `plan/allaccess_category`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allCats = responseJson?.data?.map((item) => ({
      value: item.uid,
      label: item.name,
      info: item,
    }));

    return allCats;
  } catch (error) {
    console.error("fetchAllAceessCategories=> ", error);
    throw error;
  }
};

export const fetchGymCategories = async (filters, TOKEN) => {
  // let url = `gymcat`;
  let url = `gym/category`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    // const allCats = responseJson?.data?.map((item) => ({
    //   value: item.uid,
    //   label: item.category_name,
    //   info: item,
    // }));
    const allCats = responseJson?.data?.map((item) => ({
      value: item.uid,
      label: item.name,
      info: item,
    }));

    return allCats;
  } catch (error) {
    console.error("fetchGymCategories=> ", error);
    throw error;
  }
};

export const fetchTrainerExperties = async (filters, TOKEN) => {
  let url = `trainer/expertise`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allCats = responseJson?.data?.map((item) => ({
      value: item.uid,
      label: item.name,
      info: item,
    }));

    return allCats;
  } catch (error) {
    console.error("fetchTrainerExperties=> ", error);
    throw error;
  }
};

export const fetchTrainerCategory = async (filters, TOKEN) => {
  let url = `trainer-category`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allCats = responseJson?.data?.map((item) => {
      const normalizedName = item?.name?.toLowerCase()?.replace(/\s+/g, "_");
      let label = item?.name || "NA";

      if (normalizedName === "general_trainer") {
        label = "Non PT Trainer";
      } else if (normalizedName === "personal_trainer") {
        label = "PT Trainer";
      }

      return {
        value: item?.uid,
        label: label,
        info: item,
      };
    });

    return allCats;
  } catch (error) {
    console.error("fetchTrainerCategory=> ", error);
    throw error;
  }
};

export const fetchTrainerExperienceLevel = async (filters, TOKEN) => {
  let url = `trainer/get_level`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allCats = responseJson?.data?.map((item) => ({
      value: item.uid,
      label: item.experience_level?.replace(/_/g, " ") || "-",
      info: item,
    }));

    return allCats;
  } catch (error) {
    console.error("fetchTrainerExperienceLevel=> ", error);
    throw error;
  }
};

/**
 * Adds a new shift to the master shift table (staff_shift_management).
 * Used by HR to add custom shift timings beyond the predefined 5.
 * @param {object} payload - { shift_start: "HH:MM", shift_end: "HH:MM" }
 * @param {string} TOKEN - auth token
 */
export const addShiftAPI = async (payload, TOKEN) => {
  try {
    const response = await fetch(`${BASE_URL}/user/addshift`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${TOKEN}`,
      },
      body: JSON.stringify(payload),
    });
    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error("addShiftAPI=> ", error);
    throw error;
  }
};

export const fetchReceptionistShifts = async (filters, TOKEN) => {
  let url = `user/receptionist/shifts`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allCats = responseJson?.data?.map((item) => ({
      value: item.uid,
      label: `${
        item.shift_start ? convertTo12HourFormat(item.shift_start) : ""
      }-${item.shift_end ? convertTo12HourFormat(item.shift_end) : ""}`,
      info: item,
    }));

    return allCats;
  } catch (error) {
    console.error("fetchReceptionistShifts=> ", error);
    throw error;
  }
};

export const fetchClusterManagers = async (filters, TOKEN) => {
  let url = `user?keyword=cluster_manager`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `&${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const dropdownData = responseJson?.data?.map((item) => ({
      value: item.uid,
      label: `${item.name} / ${item.mobile}`,
      info: item,
    }));

    return dropdownData;
  } catch (error) {
    console.error("fetchClusterManagers=> ", error);
    throw error;
  }
};

export const fetchVendors = async (filters, TOKEN) => {
  let url = `expense/vendor`;

  const filteredParams = Object.entries(filters)
    .filter(([key, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allCats = responseJson?.data?.map((item) => ({
      value: item?.uid,
      label: `${item?.name} (${
        item?.expense_category_name
          ? `${item.expense_category_name}${item?.gym_name ? " / " : ""}`
          : ""
      }${item?.gym_name || ""})`,
      info: item,
    }));

    return allCats;
  } catch (error) {
    console.error("fetchVendors=> ", error);
    throw error;
  }
};

export const fetchWorkoutGoals = async (filters, TOKEN) => {
  let url = `workout/goal`;

  const filteredParams = Object.entries(filters)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  if (filteredParams) {
    url += `?${filteredParams}`;
  }

  try {
    const response = await fetch(`${BASE_URL}/${url}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${TOKEN}`,
      },
    });
    const responseJson = await response.json();

    const allCats = responseJson?.data?.map((item) => ({
      value: item?.uid || "",
      label: item?.name || "-",
      info: item,
    }));

    return allCats;
  } catch (error) {
    console.error("fetchWorkoutGoals=> ", error);
    throw error;
  }
};
